import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery, useMutation, Query } from 'react-apollo';
import { GET_REFERRAL, CREATE_REFERRAL } from 'graphql/referral';
import Loading from 'components/common/Spin';
import useSnack from 'hooks/useSnack';
import Onboard from './Onboard';
import Dashboard from './Dashboard';

function generateUID() {
  let firstPart = (Math.random() * 46656) | 0;
  let secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString(36)).slice(-3);
  secondPart = ("000" + secondPart.toString(36)).slice(-3);
  return firstPart + secondPart;
}

const ReferralHome = ({ solo }) => {
  const user = useSelector(s => s.user.user);
  const [createReferral] = useMutation(CREATE_REFERRAL);
  const snack = useSnack();

  const onSignup = () => {
    window.analytics.track('Referral.Signup');
    return createReferral({
      variables: {
        data: {
          referral_code: generateUID()
        }
      },
      refetchQueries: [{
        query: GET_REFERRAL,
        variables: {
          userId: user.id
        }
      }]
    }).then(
      () => snack.success('Great! You\'ve joined referral program.'),
      (e) => snack.error(e.message)
    );
  }

  return (
    <Query query={GET_REFERRAL} variables={{userId: user.id }}>
      {({ data, loading, error }) => {
        if (loading) return <Loading />;
        if (error) return error.message;

        const [referral] = data.referrals;

        if (!referral) return <Onboard solo={solo} onSignup={onSignup} />;

        return <Dashboard solo={solo} referral={referral} />;
      }}
    </Query>
  );
  return <Dashboard />;
};

export default ReferralHome;
